import React, { FC } from 'react';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import { Tooltip } from 'app/design-system/components/Popper';
import { useTranslation } from 'app/lang';

import type { PledgeStakeDAO } from '../../../../types/backend/paymentOptions';
import TextWithAmountBar from '../../../TextWithAmountBar';

import dictionary from './PladgeStake.dictionary.json';

import styles from './PledgeStake.module.scss';

// ---

type PledgeStakeTextBarProps = {
  amountValue: string;
  value: PledgeStakeDAO;
};

const PledgeStakeTextBar: FC<PledgeStakeTextBarProps> = ({
  amountValue,
  value,
}) => {
  const { t } = useTranslation();
  const amount = Number(amountValue);

  return (
    <div className={styles.container}
         data-test="pledgeStakeTextBar-container">
      <TextWithAmountBar value={amount}
                         label={dictionary.onStakeLabel}
                         data-test="pledgeStakeTextBar-amountOnStake" />,
      <TextWithAmountBar value={value.maxWinning - amount}
                         label={dictionary.onBalanceLabel}
                         data-test="pledgeStakeTextBar-amountOnBalance"
                         className={styles.amount} />
      <Tooltip content={t(dictionary.tooltipContent)}
               data-test="pledgeStakeTextBar-tooltip"
               placement="left"
               popperClassName={styles.tooltip}>
        <Icon icon="help"
              data-test="pledgeStakeTextBar-tooltipIcon"
              size={IconSize.SMALL}
              className={styles.tooltipIcon} />
      </Tooltip>
    </div>
  );
};

export default PledgeStakeTextBar;
